
import { testimonials } from '../../../mocks/testimonials';

const Testimonials = () => {
  const featuredTestimonial = testimonials[0];

  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-6">
        <div className="max-w-4xl mx-auto text-center">
          <div className="relative mb-12">
            <i className="ri-double-quotes-l text-primary/20 text-9xl absolute -top-8 left-0 w-24 h-24 flex items-center justify-center"></i>
            <p className="font-serif text-3xl md:text-4xl text-charcoal italic leading-relaxed relative z-10 px-12">
              {featuredTestimonial.text}
            </p>
          </div>

          <div className="mb-8">
            <p className="font-bold text-xl text-charcoal">{featuredTestimonial.name}</p>
            <p className="text-gray-600">{featuredTestimonial.location}</p>
            <div className="flex justify-center mt-3 space-x-1">
              {[...Array(5)].map((_, i) => (
                <i key={i} className="ri-star-fill text-primary text-xl w-5 h-5 flex items-center justify-center"></i>
              ))}
            </div>
          </div>

          <div className="flex justify-center items-center space-x-2 mb-6">
            {testimonials.slice(0, 5).map((testimonial) => (
              <img
                key={testimonial.id}
                src={testimonial.avatar}
                alt={testimonial.name}
                className="w-16 h-16 rounded-full border-4 border-white shadow-md -ml-3 first:ml-0"
              />
            ))}
          </div>

          <p className="text-gray-600 font-medium">
            <strong className="text-primary">200+</strong> Happy Customers Across KZN
          </p>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
